import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingIndicator(props) {
    return (
    <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50px"
        flexDirection="column"
    >
            <div style={{ marginBottom: '10px', marginTop: '10px' }}>{props.Message === undefined ? '' : props.Message}</div>
            <CircularProgress color="secondary" />
    </Box>);
}